module.exports = __webpack_public_path__ + "static/img/img-activity.b33e227.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-activity.png
// module id = MkNy
// module chunks = 1